// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"135":"a61ca5e9","201":"a61ca5e9","349":"a8261e83","647":"51bb0f68"}[chunkId] + ".chunk.css";
};